// Helpers for handling js fetch

export function status(response: Response): Promise<Response | Object> {
  if (response.status === 204) {
    return Promise.resolve({ status: 'empty' });
  } else if (response.status >= 200 && response.status < 300) {
    return Promise.resolve(response);
  } else {
    return Promise.reject(response.statusText);
  }
}

export function aib400Status(response: Response): Promise<Response | Object> {
  if (response.status === 400) {
    return Promise.resolve(response);
  } else {
    return status(response);
  }
}

export function json(response: Response) {
  if (!response.json) {
    return response;
  } else {
    return response.json().then((jsonResponse) => authCheck(jsonResponse));
  }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function authCheck(jsonResponse: any) {
  if (jsonResponse.retcode && jsonResponse.retcode === '-2') {
    throw jsonResponse.retcode; // -2 expired session
  } else {
    return jsonResponse;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getDataFromResponse<T = any>(response: Response) {
  const resStatus = (await status(response)) as Response;
  return (await json(resStatus)) as T;
}
